module.exports = __webpack_public_path__ + "img/dance-test-icon7.c16a7afc.png";